<!--
 * @Author: your name
 * @Date: 2022-03-31 08:44:19
 * @LastEditTime: 2022-04-06 13:19:41
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \新建文件夹\second\do-network\src\views\pc\tech\TechRoadmapSwiper.vue
-->
<template>
  <div>
    <div class="date-container">
      <div class="date-component active-com">
        <div class="date-quarter">
          <p>{{ Q4 }}</p>
        </div>
        <div class="date-month">{{ Time }}</div>
        <div class="blue-divide"></div>
        <div class="date-desc">
          {{ TextLeft }}
        </div>
      </div>
      <div class="myswiper-container">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item, index) of dateList" :key="index">
            <div
              class="item-container"
              :class="{ active: index === realIndex }"
            >
              <div class="item-quarter">
                <p>{{ item.quarter }}</p>
              </div>
              <div class="item-month">{{ item.month }}</div>
              <div class="item-blue-divide"></div>
              <div class="item-desc">{{ item.desc }}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="swiper-Button">
        <div
          class="swiper-button-prev"
          slot="button-prev"
          @click="prev"
          :class="{ prev: flag2 === true }"
        ></div>
        <div class="swiper-scrollbar" slot="scrollbar">
          <span :style="{ marginTop: spanMargin + 'px' }"></span>
        </div>
        <div
          class="swiper-button-next"
          slot="button-next"
          @click="next"
          :class="{ prev: flag === true }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper.less";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    const _this = this;
    return {
      realIndex: 0, //轮播图滚动当前index
      spanMargin: 0,
      dateList: [
        {
          id: 1,
          quarter: "Q1",
          month: "2024-Q1",
          desc: "EVM launched, supporting ERC721/ERC20 protocols and deployment;\n Smart Contracts - Technical documentation upgraded and open-sourced;\nArk Wallet upgraded.",
        },
        {
          id: 2,
          quarter: "Q2",
          month: "2024-Q2",
          desc: "Support for cross-chain components;\n Open developer toolset; \n Launch of the Ecosystem Grant Incentive Program: DEFI/NFT/BTCLayer2/Web plugin wallet/Fairlaunch platform/DEX.",
        },
        {
          id: 3,
          quarter: "Q3",
          month: "2024-Q3",
          desc: "Host the inaugural Hackson;\n Support the expansion of the Game ecosystem;\n Facilitate full-chain interoperability;\n Promote a globally developer-driven autonomous ecosystem.",
        },
        // {
        //   id: 4,
        //   quarter: "Q1",
        //   month: "Mar 2022",
        //   desc: "Combine related modules of the DO Network.",
        // },
        // {
        //   id: 5,
        //   quarter: "Q2",
        //   month: "Apr 2022",
        //   desc: "Start the capital operation of the DO network.",
        // },
        // {
        //   id: 6,
        //   quarter: "Q2",
        //   month: "May 2022",
        //   desc: "Start the DO Network test network.",
        // },
        // {
        //   id: 7,
        //   quarter: "Q2",
        //   month: "June 2022",
        //   desc: "Enter the Test net Ark competition.",
        // },
        // {
        //   id: 8,
        //   quarter: "Q3",
        //   month: "Aug 2022",
        //   desc: "Launch the main network officially.",
        // },
        // {
        //   id: 9,
        //   quarter: "Q3",
        //   month: "Sep 2022",
        //   desc: "Launch the DAO Ecological Development Fund.",
        // },
        // {
        //   id: 10,
        //   quarter: "Q4",
        //   month: "Oct 2022",
        //   desc: "Launch the native autonomy voting for the DO network.",
        // },
        // {
        //   id: 11,
        //   quarter: "Q4",
        //   month: "Dec 2022",
        //   desc: "Start the autonomous development of open decentralization of the DAO protocol.",
        // },
      ],
      SrcH: false,
      imgHover: "../../../assets/pc/intro/Group 2444@2x.png",
      ImgHover: "../../../assets/pc/intro/Group 2445@2x.png",
      Q4: "Q1", //左侧标题
      Time: "2024-Q1", //左侧时间
      TextLeft: "\n EVM launched, supporting ERC721/ERC20 protocols and deployment; \n Smart Contracts - Technical documentation upgraded and open-sourced;\n Ark Wallet upgraded.", //左侧文本
      swiperOption: {
        direction: "vertical",
        // loop: true,
        height: 340,
        observer: true,
        observeParents: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionStart(swiper) {
            // 获取轮播图文本内容
            let dateListLeft = "";
           // dateListLeft = swiper.slides[this.realIndex].innerText+ ";\n";
            dateListLeft = `${swiper.slides[this.realIndex].innerText}`;
            _this.Q4 = dateListLeft.substr(0, 3);
            _this.Time = dateListLeft.substr(3, 9);
            _this.TextLeft = dateListLeft.substr(11, dateListLeft.length + 1);
            // 获取轮播图的index 动态添加背景演示
            _this.realIndex = this.realIndex;
          },
        },
      },
      flag: false,
      flag2: false,
      timer: null,
    };
  },
  created() {
    if (this.spanMargin === 0) {
      this.flag2 = true;
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    currentSwiperData() {
      //当前slide数据
      return this.swiperList[this.realIndex];
    },
  },
  mounted() {},
  methods: {
    // 向上滑动
    prev() {
      this.$refs.mySwiper.$swiper.slidePrev();
      if (this.spanMargin > 0 && this.spanMargin <= 360) {
        this.spanMargin = this.spanMargin - 120;
        this.flag = false;
      } else if (this.spanMargin <= 0) {
        this.spanMargin = 0;
        this.flag2 = true;
      }
    },
    // 向下滑动
    next() {
      this.$refs.mySwiper.$swiper.slideNext();
      if (this.spanMargin >= 0 && this.spanMargin < 360) {
        this.flag2 = false;
        this.spanMargin = this.spanMargin + 120;
      } else if (this.spanMargin >= 360) {
        this.spanMargin = 360;
        this.flag = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.date-container {
  width: 1200px;
  margin: 0 auto;
  padding-top: 187px;
  position: relative;
}
.date-container {
  display: flex;
  height: 640px;
  margin-top: -60px;
  &:nth-last-child(1) {
    margin-bottom: 425px;
  }
  .myswiper-container {
    flex: 1;
    // margin: 0 30px;
    width: 380px;
    height: 670px;
    overflow: hidden;
    .item-container {
      padding: 0 20px;
      width: 380px;
      height: 340px;
      background: #fafbfd;
      border-radius: 15px;
      margin-bottom: 30px;
      margin-left: 80px;
      .item-quarter {
        width: 67px;
        height: 68px;
        font-size: 45px;
        font-family: Poppins-ExtraBold, Poppins;
        font-weight: 800;
        color: rgba(52, 51, 61, 0.08);
        line-height: 68px;
        -webkit-background-clip: text;
      }
      .item-month {
        height: 68px;
        font-size: 45px;
        font-family: Poppins-ExtraBold, Poppins;
        font-weight: 800;
        color: #34333d;
        line-height: 68px;
        -webkit-background-clip: text;
      }
      .item-blue-divide {
        margin-top: 15px;
        width: 40px;
        height: 4px;
        background: #4573e7;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }
      .item-desc {
        margin-top: 45px;
        width: 286px;
        height: 42px;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #b2b2b2;
        white-space: pre-line;
        line-height: 21px;
        -webkit-background-clip: text;
      }
    }
    .active {
      background: #eff2f8 !important;
    }
  }
  .date-component {
    width: 620px;
    height: 580px;
    padding: 0 53px;
    border: 3px solid #ffffff;
    border-radius: 30px;
    box-shadow: 0px 22px 51px 1px rgba(46, 87, 192, 0.05);
    background: rgba(251, 251, 251, 0.3);
    .date-quarter {
      margin-top: 53px;
      font-size: 80px;
      font-family: Poppins-ExtraBold, Poppins;
      font-weight: 800;
      color: rgba(52, 51, 61, 0.08);
      line-height: 120px;
      -webkit-background-clip: text;
      p {
        height: 90px;
        line-height: 90px;
        font-size: 60px;
        font-family: Poppins-ExtraBold, Poppins;
        font-weight: 800;
        color: rgba(52, 51, 61, 0.08);
        -webkit-background-clip: text;
      }
    }
    .date-month {
      height: 90px;
      font-size: 80px;
      font-family: Poppins-ExtraBold, Poppins;
      font-weight: 800;
      color: #000000;
      line-height: 120px;
      -webkit-background-clip: text;
    }
    .blue-divide {
      margin-top: 47px;
      width: 60px;
      height: 6px;
      background: #4573e7;
    }
    .date-desc {
      margin: 0px 6px 0;
      height: 80px;
      font-size: 20px;
      font-family: Poppins-Regular, Poppins;
      font-weight: 400;
      color: #b2b2b2;
      line-height: 30px;
      white-space: pre-line;
      -webkit-background-clip: text;
    }
  }
}
.swiper-Button {
  width: 30px;
  height: 528px;
  box-sizing: border-box;
  position: absolute;
  top: 223px;
  right: 28px;
  z-index: 1;
  .swiper-scrollbar {
    width: 6px;
    height: 407px;
    background: rgba(215, 221, 234, 0.3);
    margin: 30px 0 30px 12px;
    span {
      width: 100%;
      height: 37px;
      display: inline-block;
      background: #4573e7;
    }
  }
  .swiper-button-prev {
    width: 30px;
    height: 30px;
    background: url("../../../assets/pc/intro/Group 2444@2x.png") 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .prev {
    pointer-events: none;
  }
  .swiper-button-prev:hover {
    background: url("../../../assets/pc/intro/Group 2445@2x.png") 0 0 no-repeat;
    background-size: 100% 100%;
    transform: rotate(180deg);
  }
  .swiper-button-next {
    width: 30px;
    height: 30px;
    background: url("../../../assets/pc/intro/Group 2444@2x.png") 0 0 no-repeat;
    background-size: 100% 100%;
    transform: rotate(180deg);
  }
  .swiper-button-next:hover {
    background: url("../../../assets/pc/intro/Group 2445@2x.png") 0 0 no-repeat;
    background-size: 100% 100%;
    transform: rotate(0deg);
  }
}
</style>
